module.exports = __webpack_public_path__ + "img/visual_service_before.49204d2.png";